<template>
  <v-container style="width: 100%" fluid>

    <default-card>
      <template slot="title-left"> Gráfico anual 📊 </template>

      <template slot="title-right">
      </template>

      <template slot="content">

        <div v-if="no_data || !chart_ready">
          <card-loading-transparent v-if="loading"/>
          <v-alert v-if="no_data && !this.loading" type="info" :value="true" class="mt-5">
            Sem nenhum registro por enquanto
          </v-alert>
        </div>

        <div style="height: 230px" v-if="chart_ready && !loading && !no_data">
          <v-sparkline
            v-if="!loading && false"
            :value="value"
            :gradient="gradient"
            :smooth="radius || false"
            :padding="padding"
            :line-width="width"
            :stroke-linecap="lineCap"
            :gradient-direction="gradientDirection"
            :fill="fill"
            :type="type"
            :auto-line-width="autoLineWidth"
            auto-draw
          ></v-sparkline>
          <bar-chart v-if="chart_ready && !loading && !no_data" style=" height: 100%; width:100%" :chart-data="chart_data" :options="chart_options"></bar-chart>
        </div>

      </template>

      <template slot="actions"> </template>
    </default-card>
  </v-container>
</template>

<script>
  const gradients = [
    ['#222'],
    ['#42b3f4'],
    ['red', 'orange', 'yellow'],
    ['purple', 'violet'],
    ['#00c6ff', '#F0F', '#FF0'],
    ['#f72047', '#ffd200', '#1feaea'],
  ]
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api'

export default {
  name: 'Invoicing',
  components: {
    BarChart: () => import('@/components/charts/BarChart.vue'),
  },
  data: () => ({
    loading: false,
    width: 5,
    radius: 10,
    padding: 20,
    lineCap: 'round',
    gradient: gradients[5],
    value: [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
    gradientDirection: 'top',
    gradients,
    fill: false,
    type: 'trend',
    autoLineWidth: false,

    chart_data: {
      datasets: [
        {
          data: [],
          backgroundColor: '#4caf50', 
          borderColor: [],
          borderWidth: 2,
          hoverBackgroundColor: [],
          label: 'Entradas',
          helper: 'income'
        },
        {
          data: [],
          backgroundColor: '#e33e43', 
          borderColor: [],
          borderWidth: 2,
          hoverBackgroundColor: [],
          label: 'Saídas',
          helper: 'outcome'
        },
      ],
      labels: [], // serão os meses
    },
    chart_options: {
      height: '10px', 
      width: '500px', 
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 20
        }
      },
      plugins:{
        datalabels: {
          anchor: 'end',
          align: 'top',
          clamp: true,
          offset: -5,
          // rotation: 90,
          color: function(ctx) {
            var is_sell = ctx.chart.data.labels[ctx.dataIndex].includes('Ab')
            return is_sell ? 'black' : 'black'
          },
          font: {
            weight: 'bold',
            size: 15
          },
          formatter: function(value, context) {
            return value>0? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : ''
          }
        }
      },
      events: ['click', 'mousemove'],
      // onClick: (e)=> {
      //   this.handleClick(e)
      // },
      // cornerRadius: 15,
      scales: {
        yAxes: [{
          display: true,
          stacked: false,
          ticks: {
            fontSize: 14
          }
        }],
        xAxes: [{
          stacked: false,
          ticks: {
            fontSize: 15
          }
          // barPercentage: 0.5,
          // categoryPercentage: 1.0
        }],
      },
      legend:{
        display: true,
        position: 'bottom',
      },
      tooltips: {
        enabled: true,
        mode: 'index',
        callbacks: {
          label: function(tooltipItems, data) { 
            return  data.datasets[tooltipItems.datasetIndex].label+ ': ' + tooltipItems.yLabel.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
          },
        }
      },
    },

    historic_data: {},
    chart_ready: false,
  }),

  methods: {
    getData(kind='income_outcome_historic', filter = {}){
      if (this.activeCompanyId){
        this.loading = true
        Api.Dashboard.showByCompany(this.activeCompanyId, kind, filter).then(r=>r.data).then(d=>{
        // d = d.top_shipping_open
        this.historic_data = {...d}
        this.loadChart()
      }).catch(err=> {
        const notification = {
          msg: err,
          type: 'error',
        }
        this.addNotification(notification)
      }).finally(()=>{
        this.loading = false
        // setTimeout(()=>this.loading = false, 1950)
      })

      }
    },
    loadChart() {
      this.chart_ready = false

      this.chart_data.labels = [...this.historic_data.months.map(d=>d.toUpperCase())]

      let map = this.chart_data.datasets.map( ({helper}) => helper) // ['income', 'outcome']
      map.forEach( (k, k_idx) => {
        this.chart_data.datasets[k_idx].data = [...this.historic_data.data[k]]//.map(d=> Math.round(d))
      })
      // let max_data = 0
      // this.chart_data.datasets.forEach(v => {
      //   max_data = [...v.data]
      // })
      // max_data = max_data.flat()
      // max_data = max_data.sort().slice(-1)
      // this.chart_options.scales.yAxes[0].ticks.max = Math.ceil(max_data * 1.15)

      // for (let idx = 0; idx < this.historic_data.data.length; idx++) {
      //   const {kind, monthly_count} = this.historic_data.data[idx];
      //   const ds_idx = this.chart_data.datasets.findIndex( ({helper}) => helper == kind)
      //   this.chart_data.datasets[ds_idx].data = [...monthly_count]
      // }
      
      
      setTimeout(() => {
        this.chart_ready = true
      }, 500);
    },

    ...mapActions({
      addNotification: 'Notification/add',
    })
  },
  computed: {
    no_data() {
      if (this.chart_ready && this.chart_data.labels.length == 0 ){
        return true
      }
      return false 
    },
    ...mapState({
      activeCompanyId: state => state.App.activeCompanyId
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getData()
  },
  watch: {
    activeCompanyId(){
      this.getData()
    }
  },

}
</script>

<style lang="scss" scoped>

</style>